export function NoItem() {
  return <div className="mx-10 mt-20  flex  justify-center rounded-md border-2 py-10">게시글이 없습니다.</div>;
}
